import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createMapper, TSaveUserEstimationMapped, TMappedResponse200 } from './mappers';
import {
  fetchSaveUserEstimation,
  ISaveUserEstimationRequest,
} from '../../../repositories/price-estimator/v2/save-user-estimation';
import { IApplicationContext } from '../../../types/customContextParams';

export const saveUserEstimationService = async (
  context: IApplicationContext,
  parameters: ISaveUserEstimationRequest,
): Promise<TMappedResponse200> => {
  try {
    const res = (await fetchSaveUserEstimation({
      httpApi: context.httpApi,
      parameters,
      mappers: createMapper(parameters),
    })) as TSaveUserEstimationMapped;

    if (res instanceof HttpBadStatusCodeError) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('save-user-estimation BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in save-user-estimation', parameters: JSON.stringify(parameters) });
    }

    throw error;
  }
};
